module.exports = __webpack_public_path__ + "img/all_icon.302c08c1.svg";